import Seo from "../Seo/Seo";
import { siteConfig } from "../../config/site";
import { useIsDanish } from "../../i18n/LanguageContext";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const isDa = useIsDanish();

  return (
    <main className="privacy-page">
      <Seo
        title={isDa ? "Privatlivspolitik | System32" : "Privacy Policy | System32"}
        description={isDa ? "Privatlivspolitik for System32, herunder hvordan kontaktformularer håndteres." : "Privacy policy for System32, including how contact form submissions are handled."}
        canonical={siteConfig.url("/privacy")}
        type="website"
      />

      <section className="privacy-hero">
        <span className="privacy-eyebrow">{isDa ? "Privatlivspolitik" : "Privacy Policy"}</span>
        <h1>{isDa ? "Sådan håndterer System32 dine data" : "How System32 handles your data"}</h1>
        <p>
          {isDa
            ? "Denne politik forklarer hvilke oplysninger vi indsamler, når du kontakter os, hvorfor vi indsamler dem, og hvordan du kan bede os opdatere eller slette dem."
            : "This policy explains what information we collect when you contact us, why we collect it, and how you can ask us to update or delete it."}
        </p>
      </section>

      <section className="privacy-content">
        <p className="privacy-updated">{isDa ? "Senest opdateret: 7. august 2026" : "Last updated: 7 August 2026"}</p>

        <h2>{isDa ? "Hvem vi er" : "Who we are"}</h2>
        <p>
          {isDa ? `${siteConfig.name} drives fra Danmark. Du kan kontakte os på` : `${siteConfig.name} is operated from Denmark. You can contact us at`}
          <a href={`mailto:${siteConfig.email}`}> {siteConfig.email}</a>{isDa ? " eller på telefon " : " or by phone at "}
          <a href={`tel:${siteConfig.phoneHref}`}>{siteConfig.phoneDisplay}</a>.
        </p>

        <h2>{isDa ? "Hvad vi indsamler" : "What we collect"}</h2>
        <p>
          {isDa
            ? "Når du sender kontaktformularen, indsamler vi de oplysninger du vælger at give os: navn, e-mailadresse, valgfrit telefonnummer og din besked."
            : "When you submit the contact form, we collect the information you choose to provide: your name, email address, optional phone number, and your message."}
        </p>

        <h2>{isDa ? "Hvorfor vi indsamler det" : "Why we collect it"}</h2>
        <p>
          {isDa
            ? "Vi bruger oplysningerne til at svare på din henvendelse, forstå dit projekt eller behov og vurdere om System32 kan hjælpe. Vi sælger ikke dine personoplysninger."
            : "We use this information to reply to your enquiry, understand your project or support need, and decide whether System32 can help. We do not sell your personal data."}
        </p>

        <h2>{isDa ? "Behandling af formularer" : "Form processing"}</h2>
        <p>
          {isDa
            ? "Kontaktformularer behandles via Formspree. Formspree kan behandle og opbevare formulardata på vores vegne, så din besked kan leveres til os."
            : "Contact form submissions are processed through Formspree. Formspree may process and store form data on our behalf so that your message can be delivered to us."}
        </p>

        <h2>{isDa ? "Hvor længe vi opbevarer det" : "How long we keep it"}</h2>
        <p>
          {isDa
            ? "Vi opbevarer henvendelsesoplysninger så længe det er nødvendigt for at svare, følge op på dialogen eller føre normale forretningsoptegnelser. Du kan til enhver tid bede os slette dine henvendelsesoplysninger."
            : "We keep enquiry information only as long as needed to respond, follow up on the conversation, or maintain normal business records. You can ask us to delete your enquiry information at any time."}
        </p>

        <h2>{isDa ? "Dine rettigheder" : "Your rights"}</h2>
        <p>
          {isDa
            ? "Du kan bede os om indsigt i, rettelse af eller sletning af personoplysninger vi har om dig. Send en anmodning til"
            : "You can ask us to access, correct, or delete personal information we hold about you. To make a request, email"}
          <a href={`mailto:${siteConfig.email}`}> {siteConfig.email}</a>.
        </p>

        <h2>{isDa ? "Ændringer til denne politik" : "Changes to this policy"}</h2>
        <p>
          {isDa
            ? "Vi kan opdatere denne politik, når vores website, kontaktproces eller juridiske forpligtelser ændrer sig. Den nyeste version vil altid være tilgængelig på denne side."
            : "We may update this policy when our website, contact process, or legal obligations change. The latest version will always be available on this page."}
        </p>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
